
import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { FormBuilder } from '@angular/forms';
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import { Validators } from '@angular/forms';
import { ValidatePhoneNumber, ValidateEmail } from '../validators/personalInfo-contact.validators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'personal-information-contact',
  templateUrl: './personal-information-contact.component.html',
  styleUrls: ['./personal-information-contact.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class personalInformationContactComponent implements OnInit {
  privacyandsecurityLink: string = "";
  currentLang: string;
  abouteObj: any = {};
  enumData: any;
  currentRoutePath: string;
  applicantName: any;
  preQualObj: any;
  loader: boolean = false;
  infoForm: any;
  coapplicantInfoForm: any;
  submitted: boolean = false;
  coSubmitted: boolean = false;
  nextProgressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  isIos: boolean;
  applicantUserObj: any;
  coApplicantUserObj: any;
  isCoapplicantApplied: boolean;
  isExistingCustomer: boolean;
  areBothCibcCustomer: boolean;
  prequalType = 'P';
  switchType = 'S';

  constructor(private el: ElementRef, private fb: FormBuilder, private util: UtilService, private _activatedRoute: ActivatedRoute, private translate: TranslateService,
    private formUtiObj: FrameworkUtilityComponent, private router: Router) {

    this.infoForm = this.fb.group({
      mobileNumber: ['', [Validators.required, ValidatePhoneNumber]],
      eMail: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9_-]+(?:\\.[a-zA-Z0-9_-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\\.)+([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])$"), ValidateEmail]],
    })

    this.coapplicantInfoForm = this.fb.group({
      mobileNumber: ['', [Validators.required, ValidatePhoneNumber]],
      eMail: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9_-]+(?:\\.[a-zA-Z0-9_-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\\.)+([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])$"), ValidateEmail]],

    })

    this.util.sidebarTitle.next('slideTitles.personalInfo');

    this.preQualObj = this.util.getSessionStorage();
    this.isCoapplicantApplied = this.preQualObj.is_coapplicant_applied == 'Y' ? true : false;
    this.isExistingCustomer = this.preQualObj.is_existing_bankcustomers == 'Y' ? true : false;
    this.areBothCibcCustomer = this.preQualObj.are_both_applicants_CIBC_customer == 'Y' ? true : false;
    let progressPercent1 = sessionStorage.getItem("progressPercentage");

    if (Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_TELL_US_ABOUT_YOURSELF_PRIMARY || CONSTANTS.PROGRESS_PERCENTAGE.NEWCUSTOMER_1_AND_EXISTINGCUSTOMER1_ADDRESSINFO || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_TELL_US_ABOUT_YOURSELF_2_CUSTOMER || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_1_TELL_US_ABOUT_YOURSELF_PRIMARY || Number(progressPercent1) == CONSTANTS.PROGRESS_PERCENTAGE.CONSENT_PRIMARY || sessionStorage.getItem("routeBack") == "true") {
      let progressPrcnt = (this.preQualObj.is_coapplicant_applied == "Y") ? CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_CONTACT_DETAILS_PRIMARY : CONSTANTS.PROGRESS_PERCENTAGE.NEW_CUSTOMER_1_CONTACT_DETAILS_PRIMARY;

      this.nextProgressPercent = progressPrcnt;
      if (this.preQualObj.users.length == 2) {
        progressPrcnt = CONSTANTS.PROGRESS_PERCENTAGE.NEWCUSTOMER_1_AND_EXISTINGCUSTOMER1_PHONE;
        sessionStorage.setItem("progressPercentage", String(progressPrcnt));

        this.util.sidebarTitle.next('slideTitles.coApplicantInfo');
      }

      this.util.progressPercent.next(progressPrcnt);

    } else {

    }

    this.util.isSidebarVisible.next(true);
    this.enumData = this.util.getEnumData();
    if (document.getElementById("sidebarTitle")) {
      document.getElementById("sidebarTitle").focus();

    }
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });

  }
  ngOnInit(): void {
    this.preQualObj.users.forEach(obj => {
      if (obj.main_application == 0) {
        this.applicantUserObj = obj;
      } else {
        this.coApplicantUserObj = obj;
      }
    })

    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);


    this.currentLang = sessionStorage.getItem("currLang")
    this.formUtiObj.InitValues();
    this.translate.get('footer.privacyandsecurityLink').subscribe((res: string) => {
      this.privacyandsecurityLink = res || "";
    });

    if (sessionStorage.getItem("routeBack") == "true") {
      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (!this.isCoapplicantApplied && !this.isExistingCustomer)) {
        this.infoForm.controls.mobileNumber.setValue(this.applicantUserObj.homenumber);
        this.infoForm.controls.eMail.setValue(this.applicantUserObj.email);
      }
      if ((this.isCoapplicantApplied && !this.isExistingCustomer) || (this.isCoapplicantApplied && this.isExistingCustomer)) {
        this.coapplicantInfoForm.controls.mobileNumber.setValue(this.coApplicantUserObj.homenumber);
        this.coapplicantInfoForm.controls.eMail.setValue(this.coApplicantUserObj.email);
      }
    }
    if (this.isIos) {
      if (sessionStorage.getItem("persTempContact")) {
        let details = JSON.parse(sessionStorage.getItem("persTempContact"));
        this.infoForm.controls.mobileNumber.setValue(details.homenumber);
        this.infoForm.controls.eMail.setValue(details.email);
      }
      if (sessionStorage.getItem("coapplicantPersTempContact")) {
        let coapplicantDetails = JSON.parse(sessionStorage.getItem("coapplicantPersTempContact"));
        this.coapplicantInfoForm.controls.mobileNumber.setValue(coapplicantDetails.homenumber);
        this.coapplicantInfoForm.controls.eMail.setValue(coapplicantDetails.email);
      }
    }
    if (document.getElementById("sidebarTitle")) {
      document.getElementById("sidebarTitle").focus();
    }
  }


  get f() {
    return this.infoForm.controls;
  }
  get cf() {
    return this.coapplicantInfoForm.controls;
  }

  persTempContact() {
    let emailObj = {
      email: this.infoForm.value.eMail,
      homenumber: this.infoForm.value.mobileNumber
    }
    if (this.isIos) {
      sessionStorage.setItem("persTempContact", JSON.stringify(emailObj))
    }
  }
  coapplicantPersTempContact() {
    let emailObj = {
      email: this.coapplicantInfoForm.value.eMail,
      homenumber: this.coapplicantInfoForm.value.mobileNumber
    }
    if (this.isIos) {
      sessionStorage.setItem("coapplicantPersTempContact", JSON.stringify(emailObj))
    }
  }
  onContinue() {
    this.submitted = true;
    this.coSubmitted = true;
    let f = this.infoForm.controls;
    let cf = this.coapplicantInfoForm.controls;
    if (this.isIos) {
      sessionStorage.removeItem("persTempContact");
      sessionStorage.removeItem("coapplicantPersTempContact");
    }
    let sessionObj = this.util.getSessionStorage();

    const isApplicantValid = f.eMail && f.mobileNumber &&
      !f.eMail.errors?.required && !f.mobileNumber.errors?.invalidNumber &&
      !f.mobileNumber.errors?.required && !f.eMail.errors?.pattern && !f.eMail.errors?.invalidEmail

    const isCoApplicantValid = cf.eMail && cf.mobileNumber &&
      !cf.eMail.errors?.required && !cf.mobileNumber.errors?.invalidNumber &&
      !cf.mobileNumber.errors?.required && !cf.eMail.errors?.pattern && !cf.eMail.errors?.invalidEmail

    const isFormValid = (this.isCoapplicantApplied && !this.isExistingCustomer)
      ? (isApplicantValid && isCoApplicantValid)
      : (!this.isCoapplicantApplied ? isApplicantValid : isCoApplicantValid);
    if (this.preQualObj.flow_type == this.switchType) {
      var errorArray = [];
      if ((this.preQualObj.is_coapplicant_applied == CONSTANTS.applicationConstants.yesVal || this.preQualObj.is_coapplicant_applied == CONSTANTS.applicationConstants.noVal) && this.preQualObj.users[0].is_existing_bankcustomer != CONSTANTS.applicationConstants.yesVal) {
        for (const key in f) {
          if (f[key].errors && f[key]) {
            var msgType = {
              type: (f[key].value != "") ? "invalid-email-address" : "missing",
              field: key,
              subtype: "",
              code: ""
            }
            errorArray.push(msgType);

          }
        }
      }
      if (this.preQualObj.is_coapplicant_applied == CONSTANTS.applicationConstants.yesVal && this.preQualObj.users[1].is_existing_bankcustomer != CONSTANTS.applicationConstants.yesVal) {
        for (const key in cf) {
          if (cf[key].errors && cf[key]) {
            var msgType = {
              type: (cf[key].value != "") ? "invalid-email-address" : "missing",
              field: key,
              subtype: "",
              code: ""
            }
            errorArray.push(msgType);
          }
        }
      }
      if (errorArray.length > 0) {
        this.util.adobeAnalyticalErrorMsg('', '', '', errorArray);
      }
    }
    if (isFormValid) {

      if (!this.isCoapplicantApplied || !this.isExistingCustomer) {
        this.applicantUserObj.email = this.infoForm.value.eMail;
        this.applicantUserObj.homenumber = this.infoForm.value.mobileNumber;
        this.applicantUserObj.mobilenumber = "+1 " + this.applicantUserObj.homenumber.substring(0, 3) + "-" + this.applicantUserObj.homenumber.substring(3, 6) + "-" + this.applicantUserObj.homenumber.substring(6, 10);
      }
      if (this.isCoapplicantApplied || this.isExistingCustomer) {
        this.coApplicantUserObj.email = this.coapplicantInfoForm.value.eMail;
        this.coApplicantUserObj.homenumber = this.coapplicantInfoForm.value.mobileNumber;
        this.coApplicantUserObj.mobilenumber = "+1 " + this.coApplicantUserObj.homenumber.substring(0, 3) + "-" + this.coApplicantUserObj.homenumber.substring(3, 6) + "-" + this.coApplicantUserObj.homenumber.substring(6, 10);

      }

      sessionObj.users.forEach((user, index) => {
        if (user.main_application == 0) {
          sessionObj.users[index] = this.applicantUserObj;
        } else {
          sessionObj.users[index] = this.coApplicantUserObj;
        }
      })

      this.util.setSessionStorage(sessionObj);


      sessionStorage.setItem("progressPercentage", String(this.nextProgressPercent));


      if (sessionStorage.getItem("routeBack") == "true") {
        this.router.navigate(['../personal-information-preview'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      else {
        this.router.navigate([this.util.determineNextRoute(this.currentRoutePath)], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
    }


    for (const key of Object.keys(this.infoForm.controls)) {
      if (this.infoForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
        invalidControl.focus();
        break;
      }
    }
    for (const key of Object.keys(this.coapplicantInfoForm.controls)) {
      if (this.coapplicantInfoForm.controls[key].invalid) {
        const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
        invalidControl.focus();
        break;
      }
    }
  }
}
